interface Skill {
  label: string;
  initial: number;
  keywords: string[];
}

export const skillList6th: Skill[] = [
  {
    label: '言いくるめ',
    initial: 5,
    keywords: ['言いくるめ', 'いいくるめ', 'iikurume'],
  },
  {
    label: '医学',
    initial: 5,
    keywords: ['医学', 'いがく', 'igaku'],
  },
  {
    label: '運転',
    initial: 20,
    keywords: ['運転', 'うんてん', 'unten'],
  },
  {
    label: '応急手当',
    initial: 30,
    keywords: ['応急手当', 'おうきゅうてあて', 'oukyuteate'],
  },
  {
    label: 'オカルト',
    initial: 5,
    keywords: ['オカルト', 'おかると', 'occult'],
  },
  {
    label: '回避',
    initial: 0,
    keywords: ['回避', 'かいひ', 'kaihi'],
  },
  {
    label: '化学',
    initial: 1,
    keywords: ['化学', 'かがく', 'kagaku'],
  },
  {
    label: '鍵開け',
    initial: 1,
    keywords: ['鍵開け', 'かぎあけ', 'kagiake'],
  },
  {
    label: '隠す',
    initial: 15,
    keywords: ['隠す', 'かくす', 'kakusu'],
  },
  {
    label: '隠れる',
    initial: 10,
    keywords: ['隠れる', 'かくれる', 'kakureru'],
  },
  {
    label: '機械修理',
    initial: 20,
    keywords: ['機械修理', 'きかいしゅうり', 'kikaisyuri'],
  },
  {
    label: '聞き耳',
    initial: 25,
    keywords: ['聞き耳', 'ききみみ', 'kikimimi'],
  },
  {
    label: 'クトゥルフ神話',
    initial: 0,
    keywords: ['クトゥルフ神話', 'くとぅるふしんわ', 'cthulhushinwa'],
  },
  {
    label: '芸術',
    initial: 5,
    keywords: ['芸術', 'げいじゅつ', 'geizyutsu'],
  },
  {
    label: '経理',
    initial: 10,
    keywords: ['経理', 'けいり', 'keiri'],
  },
  {
    label: '考古学',
    initial: 1,
    keywords: ['考古学', 'こうこがく', 'koukogaku'],
  },
  {
    label: 'コンピューター',
    initial: 1,
    keywords: ['コンピューター', 'こんぴゅーたー', 'computer'],
  },
  {
    label: '忍び歩き',
    initial: 10,
    keywords: ['忍び歩き', 'しのびあるき', 'shinobiaruki'],
  },
  {
    label: '写真術',
    initial: 10,
    keywords: ['写真術', 'しゃしんじゅつ', 'shashinjutsu'],
  },
  {
    label: '重機械操作',
    initial: 1,
    keywords: ['重機械操作', 'じゅうきかいそうさ', 'jukikaisousa'],
  },
  {
    label: '乗馬',
    initial: 5,
    keywords: ['乗馬', 'じょうば', 'joba'],
  },
  {
    label: '信用',
    initial: 15,
    keywords: ['信用', 'しんよう', 'shinyou'],
  },
  {
    label: '心理学',
    initial: 5,
    keywords: ['心理学', 'しんりがく', 'shinrigaku'],
  },
  {
    label: '人類学',
    initial: 1,
    keywords: ['人類学', 'じんるいがく', 'jinruigaku'],
  },
  {
    label: '水泳',
    initial: 25,
    keywords: ['水泳', 'すいえい', 'suiei'],
  },
  {
    label: '製作',
    initial: 5,
    keywords: ['製作', 'せいさく', 'seisaku'],
  },
  {
    label: '精神分析',
    initial: 1,
    keywords: ['精神分析', 'せいしんぶんせき', 'seishinbunseki'],
  },
  {
    label: '生物学',
    initial: 1,
    keywords: ['生物学', 'せいぶつがく', 'seibutsugaku'],
  },
  {
    label: '説得',
    initial: 15,
    keywords: ['説得', 'せっとく', 'settoku'],
  },
  {
    label: '操縦',
    initial: 1,
    keywords: ['操縦', 'そうじゅう', 'souju'],
  },
  {
    label: '地質学',
    initial: 1,
    keywords: ['地質学', 'ちしつがく', 'chishitsugaku'],
  },
  {
    label: '跳躍',
    initial: 25,
    keywords: ['跳躍', 'ちょうやく', 'choyaku'],
  },
  {
    label: '追跡',
    initial: 10,
    keywords: ['追跡', 'ついせき', 'tsuiseki'],
  },
  {
    label: '電気修理',
    initial: 10,
    keywords: ['電気修理', 'でんきしゅうり', 'denkishuri'],
  },
  {
    label: '電子工学',
    initial: 1,
    keywords: ['電子工学', 'でんしこうがく', 'denshikogaku'],
  },
  {
    label: '天文学',
    initial: 1,
    keywords: ['天文学', 'てんもんがく', 'tenmongaku'],
  },
  {
    label: '投擲',
    initial: 25,
    keywords: ['投擲', 'とうてき', 'touteki'],
  },
  {
    label: '登攀',
    initial: 40,
    keywords: ['登攀', 'とうはん', 'tohan'],
  },
  {
    label: '図書館',
    initial: 25,
    keywords: ['図書館', 'としょかん', 'toshokan'],
  },
  {
    label: 'ナビゲート',
    initial: 10,
    keywords: ['ナビゲート', 'なびげーと', 'navigate'],
  },
  {
    label: '値切り',
    initial: 5,
    keywords: ['値切り', 'ねぎり', 'negiri'],
  },
  {
    label: '博物学',
    initial: 10,
    keywords: ['博物学', 'はくぶつがく', 'hakubutsugaku'],
  },
  {
    label: '物理学',
    initial: 1,
    keywords: ['物理学', 'ぶつりがく', 'butsurigaku'],
  },
  {
    label: '変装',
    initial: 1,
    keywords: ['変装', 'へんそう', 'hensou'],
  },
  {
    label: '法律',
    initial: 5,
    keywords: ['法律', 'ほうりつ', 'horitsu'],
  },
  {
    label: 'ほかの言語',
    initial: 1,
    keywords: ['ほかの言語', 'ほかのげんご', 'hokanogengo'],
  },
  {
    label: '母国語',
    initial: 0,
    keywords: ['母国語', 'ぼこくご', 'bokokugo'],
  },
  {
    label: 'マーシャルアーツ',
    initial: 1,
    keywords: ['マーシャルアーツ', 'まーしゃるあーつ', 'martial arts'],
  },
  {
    label: '目星',
    initial: 25,
    keywords: ['目星', 'めぼし', 'meboshi'],
  },
  {
    label: '薬学',
    initial: 1,
    keywords: ['薬学', 'やくがく', 'yakugaku'],
  },
  {
    label: '歴史',
    initial: 20,
    keywords: ['歴史', 'れきし', 'rekishi'],
  },
  {
    label: '拳銃',
    initial: 20,
    keywords: ['拳銃', 'けんじゅう', 'kenju'],
  },
  {
    label: 'サブマシンガン',
    initial: 15,
    keywords: ['サブマシンガン', 'さぶましんがん', 'submachine gun'],
  },
  {
    label: 'ショットガン',
    initial: 30,
    keywords: ['ショットガン', 'しょっとがん', 'shotgun'],
  },
  {
    label: 'マシンガン',
    initial: 15,
    keywords: ['マシンガン', 'ましんがん', 'machine gun'],
  },
  {
    label: 'ライフル',
    initial: 25,
    keywords: ['ライフル', 'らいふる', 'rifle'],
  },
  {
    label: 'キック',
    initial: 25,
    keywords: ['キック', 'きっく', 'kick'],
  },
  {
    label: '組みつき',
    initial: 25,
    keywords: ['組みつき', 'くみつき', 'kumitsuki'],
  },
  {
    label: 'こぶし',
    initial: 50,
    keywords: ['拳', 'こぶし', 'kobushi'],
  },
  {
    label: '頭突き',
    initial: 10,
    keywords: ['頭突き', 'ずつき', 'dsutsuki'],
  },
  {
    label: '固有技能',
    initial: 0,
    keywords: ['固有技能', 'こゆうぎのう', 'koyugino'],
  },
];

export const skillList7th: Skill[] = [
  {
    label: '威圧',
    initial: 15,
    keywords: ['威圧', 'いあつ', 'iatsu'],
  },
  {
    label: '言いくるめ',
    initial: 5,
    keywords: ['言いくるめ', 'いいくるめ', 'iikurume'],
  },
  {
    label: '医学',
    initial: 1,
    keywords: ['医学', 'いがく', 'igaku'],
  },
  {
    label: '運転',
    initial: 20,
    keywords: ['運転', 'うんてん', 'unten'],
  },
  {
    label: '応急手当',
    initial: 30,
    keywords: ['応急手当', 'おうきゅうてあて', 'oukyuteate'],
  },
  {
    label: 'オカルト',
    initial: 5,
    keywords: ['オカルト', 'おかると', 'occult'],
  },
  {
    label: '隠密',
    initial: 20,
    keywords: ['隠密', 'おんみつ', 'onmitsu'],
  },
  {
    label: '回避',
    initial: 0,
    keywords: ['回避', 'かいひ', 'kaihi'],
  },
  {
    label: '科学[暗号学]',
    initial: 1,
    keywords: ['科学[暗号学]', '暗号学', 'あんごうがく', 'angougaku'],
  },
  {
    label: '科学[化学]',
    initial: 1,
    keywords: ['科学[化学]', '化学', 'かがく', 'kagaku'],
  },
  {
    label: '科学[気象学]',
    initial: 1,
    keywords: ['科学[気象学]', '気象学', 'きしょうがく', 'kisyougaku'],
  },
  {
    label: '科学[工学]',
    initial: 1,
    keywords: ['科学[工学]', '工学', 'こうがく', 'kougaku'],
  },
  {
    label: '科学[植物学]',
    initial: 1,
    keywords: ['科学[植物学]', '植物学', 'しょくぶつがく', 'syokubutsugaku'],
  },
  {
    label: '科学[数学]',
    initial: 10,
    keywords: ['科学[数学]', '数学', 'すうがく', 'suugaku'],
  },
  {
    label: '科学[生物学]',
    initial: 1,
    keywords: ['科学[生物学]', '生物学', 'せいぶつがく', 'seibutsugaku'],
  },
  {
    label: '科学[地質学]',
    initial: 1,
    keywords: ['科学[地質学]', '地質学', 'ちしつがく', 'chishitsugaku'],
  },
  {
    label: '科学[天文学]',
    initial: 1,
    keywords: ['科学[天文学]', '天文学', 'てんもんがく', 'tenmongaku'],
  },
  {
    label: '科学[動物学]',
    initial: 1,
    keywords: ['科学[動物学]', '動物学', 'どうぶつがく', 'doubutsugaku'],
  },
  {
    label: '科学[物理学]',
    initial: 1,
    keywords: ['科学[物理学]', '物理学', 'ぶつりがく', 'butsurigaku'],
  },
  {
    label: '科学[法医学]',
    initial: 1,
    keywords: ['科学[法医学]', '法医学', 'ほういがく', 'houigaku'],
  },
  {
    label: '科学[薬学]',
    initial: 1,
    keywords: ['科学[薬学]', '薬学', 'やくがく', 'yakugaku'],
  },
  {
    label: '鍵開け',
    initial: 1,
    keywords: ['鍵開け', 'かぎあけ', 'kagiake'],
  },
  {
    label: '鑑定',
    initial: 5,
    keywords: ['鑑定', 'かんてい', 'kantei'],
  },
  {
    label: '機械修理',
    initial: 10,
    keywords: ['機械修理', 'きかいしゅうり', 'kikaisyuri'],
  },
  {
    label: '聞き耳',
    initial: 20,
    keywords: ['聞き耳', 'ききみみ', 'kikimimi'],
  },
  {
    label: 'クトゥルフ神話',
    initial: 0,
    keywords: ['クトゥルフ神話', 'くとぅるふしんわ', 'cthulhushinwa'],
  },
  {
    label: '芸術/製作',
    initial: 5,
    keywords: ['芸術/製作', '芸術', '製作', 'げいじゅつ', 'せいさく', 'geizyutsu', 'seisaku'],
  },
  {
    label: '経理',
    initial: 5,
    keywords: ['経理', 'けいり', 'keiri'],
  },
  {
    label: '考古学',
    initial: 1,
    keywords: ['考古学', 'こうこがく', 'koukogaku'],
  },
  {
    label: 'コンピューター',
    initial: 5,
    keywords: ['コンピューター', 'こんぴゅーたー', 'computer'],
  },
  {
    label: 'サバイバル[専門分野]',
    initial: 10,
    keywords: ['サバイバル', 'さばいばる', 'survival'],
  },
  {
    label: '自然',
    initial: 10,
    keywords: ['自然', 'しぜん', 'shizen'],
  },
  {
    label: '重機械操作',
    initial: 1,
    keywords: ['重機械操作', 'じゅうきかいそうさ', 'jukikaisousa'],
  },
  {
    label: '乗馬',
    initial: 5,
    keywords: ['乗馬', 'じょうば', 'joba'],
  },
  {
    label: '信用',
    initial: 0,
    keywords: ['信用', 'しんよう', 'shinyou'],
  },
  {
    label: '心理学',
    initial: 10,
    keywords: ['心理学', 'しんりがく', 'shinrigaku'],
  },
  {
    label: '人類学',
    initial: 1,
    keywords: ['人類学', 'じんるいがく', 'jinruigaku'],
  },
  {
    label: '水泳',
    initial: 20,
    keywords: ['水泳', 'すいえい', 'suiei'],
  },
  {
    label: '精神分析',
    initial: 1,
    keywords: ['精神分析', 'せいしんぶんせき', 'seishinbunseki'],
  },
  {
    label: '説得',
    initial: 10,
    keywords: ['説得', 'せっとく', 'settoku'],
  },
  {
    label: '操縦[専門分野]',
    initial: 1,
    keywords: ['操縦', 'そうじゅう', 'souju'],
  },
  {
    label: 'ダイビング',
    initial: 1,
    keywords: ['ダイビング', 'だいびんぐ', 'diving'],
  },
  {
    label: '跳躍',
    initial: 20,
    keywords: ['跳躍', 'ちょうやく', 'choyaku'],
  },
  {
    label: '追跡',
    initial: 10,
    keywords: ['追跡', 'ついせき', 'tsuiseki'],
  },
  {
    label: '手さばき',
    initial: 10,
    keywords: ['手さばき', 'てさばき', 'tesabaki'],
  },
  {
    label: '電気修理',
    initial: 10,
    keywords: ['電気修理', 'でんきしゅうり', 'denkishuri'],
  },
  {
    label: '電子工学',
    initial: 1,
    keywords: ['電子工学', 'でんしこうがく', 'denshikogaku'],
  },
  {
    label: '伝承',
    initial: 1,
    keywords: ['伝承', 'でんしょう', 'densyou'],
  },
  {
    label: '投擲',
    initial: 20,
    keywords: ['投擲', 'とうてき', 'touteki'],
  },
  {
    label: '登攀',
    initial: 20,
    keywords: ['登攀', 'とうはん', 'tohan'],
  },
  {
    label: '動物使い',
    initial: 5,
    keywords: ['動物使い', 'どうぶつつかい', 'doubutsutsukai'],
  },
  {
    label: '読唇術',
    initial: 1,
    keywords: ['読唇術', 'どくしんじゅつ', 'dokushinjutsu'],
  },
  {
    label: '図書館',
    initial: 20,
    keywords: ['図書館', 'としょかん', 'toshokan'],
  },
  {
    label: 'ナビゲート',
    initial: 10,
    keywords: ['ナビゲート', 'なびげーと', 'navigate'],
  },
  {
    label: '爆破',
    initial: 1,
    keywords: ['爆破', 'ばくは', 'bakuha'],
  },
  {
    label: 'ヒプノーシス',
    initial: 1,
    keywords: ['ヒプノーシス', 'ひぷのーしす', 'hypnosis'],
  },
  {
    label: '博物学',
    initial: 10,
    keywords: ['博物学', 'はくぶつがく', 'hakubutsugaku'],
  },
  {
    label: '変装',
    initial: 5,
    keywords: ['変装', 'へんそう', 'hensou'],
  },
  {
    label: '法律',
    initial: 5,
    keywords: ['法律', 'ほうりつ', 'horitsu'],
  },
  {
    label: 'ほかの言語[専門分野]',
    initial: 1,
    keywords: ['ほかの言語', 'ほかのげんご', 'hokanogengo'],
  },
  {
    label: '母国語',
    initial: 0,
    keywords: ['母国語', 'ぼこくご', 'bokokugo'],
  },
  {
    label: '魅惑',
    initial: 15,
    keywords: ['魅惑', 'みわく', 'miwaku'],
  },
  {
    label: '目星',
    initial: 25,
    keywords: ['目星', 'めぼし', 'meboshi'],
  },
  {
    label: '歴史',
    initial: 5,
    keywords: ['歴史', 'れきし', 'rekishi'],
  },
  {
    label: '近接戦闘[斧]',
    initial: 15,
    keywords: ['近接戦闘[斧]', '斧', 'おの', 'ono'],
  },
  {
    label: '近接戦闘[格闘]',
    initial: 25,
    keywords: ['近接戦闘[格闘]', '格闘', 'かくとう', 'kakutou'],
  },
  {
    label: '近接戦闘[絞殺ひも]',
    initial: 15,
    keywords: ['近接戦闘[絞殺ひも]', '絞殺ひも', 'こうさつひも', 'kousatsuhimo'],
  },
  {
    label: '近接戦闘[チェーンソー]',
    initial: 10,
    keywords: ['近接戦闘[チェーンソー]', 'チェーンソー', 'ちぇーんそー', 'chain saw'],
  },
  {
    label: '近接戦闘[刀剣]',
    initial: 20,
    keywords: ['近接戦闘[刀剣]', '刀剣', 'とうけん', 'touken'],
  },
  {
    label: '近接戦闘[フレイル]',
    initial: 10,
    keywords: ['近接戦闘[フレイル]', 'フレイル', 'ふれいる', 'frail'],
  },
  {
    label: '近接戦闘[むち]',
    initial: 5,
    keywords: ['近接戦闘[むち]', 'むち', 'muchi'],
  },
  {
    label: '近接戦闘[槍]',
    initial: 20,
    keywords: ['近接戦闘[槍]', '槍', 'やり', 'yari'],
  },
  {
    label: '射撃[火炎放射器]',
    initial: 10,
    keywords: ['射撃[火炎放射器]', '火炎放射器', 'かえんほうしゃき', 'kaenhousyaki'],
  },
  {
    label: '射撃[拳銃]',
    initial: 20,
    keywords: ['射撃[拳銃]', '拳銃', 'けんじゅう', 'kenzyu'],
  },
  {
    label: '射撃[サブマシンガン]',
    initial: 15,
    keywords: ['射撃[サブマシンガン]', 'サブマシンガン', 'さぶましんがん', 'submachine gun'],
  },
  {
    label: '射撃[重火器]',
    initial: 10,
    keywords: ['射撃[重火器]', '重火器', 'じゅうかき', 'jukaki'],
  },
  {
    label: '射撃[マシンガン]',
    initial: 10,
    keywords: ['射撃[マシンガン]', 'マシンガン', 'ましんがん', 'machine gun'],
  },
  {
    label: '射撃[弓]',
    initial: 15,
    keywords: ['射撃[弓]', '弓', 'ゆみ', 'yumi'],
  },
  {
    label: '射撃[ライフル/ショットガン]',
    initial: 25,
    keywords: [
      '射撃[ライフル/ショットガン]',
      'ライフル',
      'ショットガン',
      'らいふる',
      'しょっとがん',
      'rifle',
      'shotgun',
    ],
  },
  {
    label: '固有技能',
    initial: 0,
    keywords: ['固有技能', 'こゆうぎのう', 'koyugino'],
  },
];
